import React from 'react'

import { BaseView } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { ButtonProps } from '@/components/AppButton/types'
import { useTheme } from '@/hooks/useTheme'
import useOffsets from '@/hooks/useOffsets'

export interface FixedBottomTwoButtonsProps {
  /**
   * Левая кнопка (обычно отмена/назад)
   */
  leftButton: ButtonProps

  /**
   * Правая кнопка (обычно основное действие)
   */
  rightButton: ButtonProps

  /**
   * Показывать ли верхнюю границу
   * @default true
   */
  showBorder?: boolean

  /**
   * Дополнительные стили для контейнера
   */
  containerStyle?: React.CSSProperties

  /**
   * Z-index для позиционирования
   * @default 1000
   */
  zIndex?: number

  /**
   * Дополнительный отступ снизу (добавляется к offsets.bottom)
   * @default 12
   */
  additionalBottomPadding?: number
}

export const FixedBottomTwoButtons: React.FC<FixedBottomTwoButtonsProps> = ({
  leftButton,
  rightButton,
  showBorder = true,
  containerStyle,
  zIndex = 1000,
  additionalBottomPadding = 12,
}) => {
  const theme = useTheme()
  const offsets = useOffsets()

  return (
    <BaseView
      px={12}
      pt={8}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.colors.background.screen,
        paddingBottom: `${offsets.bottom}px`,
        zIndex,
        ...containerStyle,
      }}
    >
      <BaseView row gap={12}>
        <AppButton isSharedSpace {...leftButton} />
        <AppButton isSharedSpace {...rightButton} />
      </BaseView>
    </BaseView>
  )
}

export default FixedBottomTwoButtons
